import React, { useState } from "react";
import "../assets/css/ticker.css";

const Ticker = () => {
  const [isPaused, setIsPaused] = useState(false);

  // Prevent pausing when clicking the link
  const handleContainerClick = (e) => {
    if (e.target.tagName.toLowerCase() !== "a") {
      setIsPaused(true);
    }
  };

  return (
    <div
      className="ticker-container"
      onClick={handleContainerClick}
      style={{ cursor: isPaused ? "default" : "pointer" }}
      title={isPaused ? undefined : "Click to stop scrolling"}
    >
      <div className={`ticker-text${isPaused ? " paused" : ""}`}>
        Search local jobs anywhere in India. Click{" "}
        <a
          href="https://play.google.com/store/apps/details?id=com.trustapp"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#fff",
            textDecoration: "underline",
            fontWeight: 600,
          }}
        >
          here
        </a>{" "}
        & Install app, no need to create profile in app. Simply Install & use. In
        bottom section of home page click 🚀 to go to Local job section.
      </div>
    </div>
  );
};

export default Ticker;
